'use strict';

var debounce = function (fn, delay) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeout);
        if (delay) {
            timeout = setTimeout(function () {
                fn.apply(void 0, args);
            }, delay);
        }
        else {
            fn.apply(void 0, args);
        }
    };
};

exports.debounce = debounce;
//# sourceMappingURL=debounce-d1f5a67b.js.map
